import { render, staticRenderFns } from "./TeamMobileCardUserDetails.vue?vue&type=template&id=99d251ca&scoped=true"
import script from "./TeamMobileCardUserDetails.vue?vue&type=script&lang=js"
export * from "./TeamMobileCardUserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d251ca",
  null
  
)

export default component.exports